module.exports = __webpack_public_path__ + "images/a48640d2be6200c0620fb93a244d288f-eurail.png";